module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAATlBMVEUAAADAJi2/ICDBJi3CJyvAJyzBJyzDJCy/JSq/KCjBJizCJi3AJizAJizBJizCJSzBJyzBJy3////78fHUaW7MTlPEMznsvL7su73gkpVeBnN9AAAAEXRSTlMA8BCgcODAQDAgsFDQz4BfkPf/Yk8AAADISURBVDjLrZHpEsIwCISlgZjayzU93/9FnUlj0ZhOx+P7RdgdIHD6M2yJLO/KrkGgcXm9IAyz9/MAKrKGC/pboMclp5cY/WrwI8qMoQoFYokqY2ixPAwL2sMKhzN8+Avdw+T9pHtIcTUCtTu6xZeUbAUBsVy+T2jwgknmdAQYPq+PMxtAXKJLVKNHQO55A1pSW4qm9KEUAqNXgNbXLtguwqs3xYBjZNcohWFjRKFDpofECEikNE/ocnoH2abZ4botRZCBdHk/cQeTNxBGl4L7mQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.png
// module id = A1tS
// module chunks = 1